import uniqueId from 'lodash/uniqueId';
import containerBuilder from './container';
import paddingModifier from '../props/padding-modifier';
import actionParser from '../props/action';
import numericSize, { numericSizeFactory } from '../props/numeric-size';
import { numberToBool } from '../props/bool-helper';
import urlParser from '../props/url';
import color from '../props/color';
import text from '../props/text';
import textStyle from '../props/text-style';
import { getMaxWeight } from '../../util';
import { GALLERY_DEFAULT_PADDINGS as PADDINGS, TAIL_ICON_COLOR as ICON_COLOR, BLOCK } from '../const';

/**
 * Билдер блока div-gallery-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-tabs-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var rawItems = block.items;

    if (!rawItems || !rawItems.length) {
        return null;
    }

    var items = rawItems.map(itemBuilder).filter(Boolean);

    if (!items.length) {
        return null;
    }

    return {
        action: actionParser(block),
        type: block.type,
        hasDelimiter: numberToBool(block.has_delimiter),
        paddingModifier: paddingModifier(block),
        items: items,
        paddingBetweenItems: numericSize(block.padding_between_items, numericSizeFactory(PADDINGS.between)),
        tail: tailBuilder(block.tail),
        id: uniqueId('block_'),
        weight: getMaxWeight(items),
        hasGallery: true
    };
});

var itemBuilder = function itemBuilder(item) {
    if (!item || item.type !== BLOCK.container) {
        return null;
    }

    return containerBuilder(item);
};

var iconBuilder = function iconBuilder(data) {
    var icon = data || {};

    return {
        imageUrl: urlParser(icon.image_url),
        iconColor: color(icon.icon_color, ICON_COLOR.icon),
        borderColor: color(icon.border_color, ICON_COLOR.border),
        fillColor: color(icon.fill_color, ICON_COLOR.fill)
    };
};

var tailBuilder = function tailBuilder(tail) {
    if (!tail) {
        return null;
    }

    var action = actionParser(tail);

    if (!action) {
        return null;
    }

    var icon = iconBuilder(tail.icon);

    if (!icon) {
        return null;
    }

    return {
        action: action,
        icon: icon,
        text: text(tail.text),
        textStyle: textStyle(tail.textStyle)
    };
};